module.exports = __webpack_public_path__ + "static/media/soon.0682ef01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/soon.jpg
// module id = 828
// module chunks = 3